import { createContext } from "react";
import { ScreenData } from "../../types/ScreenTypes";

export interface HouseholdWording {
  // The word for the congregation prayer; unset means "Jama'ah".
  jamaat?: string;
  // Spellings that replace the masjid's own; unset keeps the masjid's.
  names?: Partial<Record<"dhuhr" | "asar" | "isha" | "jummah", string>>;
}

// Provided by the /home shell only, so wall screens keep their masjid's wording.
export const HouseholdWordingContext = createContext<HouseholdWording | null>(null);

export const withHouseholdWording = (
  screenData: ScreenData,
  wording: HouseholdWording | null,
): ScreenData => {
  if (!wording || !screenData) return screenData;
  const names = Object.fromEntries(
    Object.entries(wording.names ?? {}).filter(([, value]) => value),
  );
  return {
    ...screenData,
    customizedNames: {
      ...screenData.customizedNames,
      ...names,
      ...(wording.jamaat ? { jamaat: wording.jamaat } : {}),
    },
  };
};
